import * as React from "react";

import { TableCell } from "@/components/ui/table";
import { cn } from "@/lib/utils";

export function TableShell({ className, ...props }: React.ComponentProps<"div">) {
  return <div className={cn("overflow-x-auto rounded-md border", className)} {...props} />;
}

export interface TableEmptyRowProps extends React.ComponentProps<typeof TableCell> {
  colSpan: number;
}

export function TableEmptyRow({ className, children, colSpan, ...props }: TableEmptyRowProps) {
  return (
    <TableCell
      colSpan={colSpan}
      className={cn("h-20 text-center text-sm text-muted-foreground", className)}
      {...props}
    >
      {children}
    </TableCell>
  );
}
